<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12 sm6>
        <basic-info></basic-info>
      </v-flex>
       <v-flex xs12 sm6>
        <v-card flat tile class="elevation-2">
          <security></security>
        </v-card>
      </v-flex>
       <v-flex xs12 sm6>
        <v-card flat tile class="elevation-2">
          <pin></pin>
        </v-card>
      </v-flex>
      <v-flex sm12 md12>
        <invitation-list></invitation-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex';
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import invitationList from './PageComponents/Settings/InvitationList';
import basicInfo from './PageComponents/Settings/BasicInfo';
import security from './PageComponents/Settings/Security';
import pin from './PageComponents/Settings/Pin';

export default {
  components: {
    invitationList,
    basicInfo,
    security,
    pin,
  },
  data() {
    return {

    };
  },
  created() {
    this.getUserInfos();
  },
  
  methods: {
    /**
     * Get all users for business
     */
    getUserInfos() {
      const url = `${Env.url}/api/v1/users/me`;
      AuthApi.getApi(url)
      .then((res) => {
        this.setInvitationList(res.data.invitations);
        this.setBasicInformationList(res.data.user);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },
   
    ...mapActions({
      snackbar: 'snackbar/snackbar',
      setInvitationList: 'setting/setInvitationList',
      setBasicInformationList: 'setting/setBasicInformationList',
    }),

  },
};
</script>